module.exports = __webpack_public_path__ + "img/album02_08.ce82d756.jpg";